// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"2a9129ecaa37f08a","6172":"301ff7dfa837ef78"}[chunkId] + ".css";
};